import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { Box, Container, Group, Image, Stack } from '@optiro/ui';

import { PartnerClaimSelectView } from '@/modules/SharedPlanning/components/PartnerClaim/PartnerClaimSelectView';
import { ShadowPartner, useShadowPartners } from '@/modules/SharedPlanning/hooks';

import logo from '../optiro.svg';

export const Route = createFileRoute('/shared/projects/$sharedProjectId/claim/')({
  component: ClaimSelectComponent,
});

function ClaimSelectComponent() {
  const { sharedProjectId } = Route.useParams();
  const navigate = useNavigate();
  const { data: shadowPartners, isLoading } = useShadowPartners({ token: sharedProjectId });

  const handleSelect = (partner: ShadowPartner) =>
    navigate({
      to: '/shared/projects/$sharedProjectId/claim/form',
      params: { sharedProjectId },
      search: { partnerId: partner.id },
    });

  return (
    <div style={{ minHeight: '100vh', backgroundColor: 'rgb(248, 245, 239)' }}>
      <Box style={{ borderBottom: '1px solid #e9ecef', backgroundColor: 'white' }}>
        <Container size="sm">
          <Group justify="center" py="md">
            <Image src={logo} alt="Optiro" h={32} w="auto" />
          </Group>
        </Container>
      </Box>

      <Container size="sm" py="xl">
        <Stack maw={480} mx="auto">
          <PartnerClaimSelectView
            shadowPartners={shadowPartners}
            isLoading={isLoading}
            onSelect={handleSelect}
          />
        </Stack>
      </Container>
    </div>
  );
}
